import React, { useState, useEffect } from "react";
import useAdaptiveStatus from "../hooks/useAdaptiveStatus";

const ThinkingDots = ({ isGenerating, streamedText, promptText }) => {
  const [dots, setDots] = useState("");

  const statusMessage = useAdaptiveStatus({
    isGenerating,
    streamedText,   // live tokens from the stream
    promptText,     // the user's prompt for early signal
    updateEveryMs: 1400,
  });

  // animate trailing dots only while generating
  useEffect(() => {
    if (!isGenerating) return;
    setDots(""); // reset on new turn
    const id = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? "" : prev + "."));
    }, 500);
    return () => clearInterval(id);
  }, [isGenerating]);

  if (!isGenerating) return null;

  // If the status already ends with a period or ellipsis, don't add animated dots
  const endsWithEllipsis = /[\.\u2026]$/.test(statusMessage || "");
  const rendered = endsWithEllipsis ? (statusMessage || "Thinking…") : `${statusMessage || "Thinking…"}${dots}`;

  return (
    <div className="text-center text-white font-medium italic animate-pulse" aria-live="polite">
      {rendered}
    </div>
  );
};

export default ThinkingDots;
